import { inject } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { AuthService } from "../services/api/auth/auth.service";

export const growerGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
): boolean => {
  // Inject AuthService and Router
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.hasRole("GROWER")) {
    return true;
  } else {
    router.navigate(["/signup"]);
    return false;
  }
};
